import { Dialog } from '@material-ui/core';
import ChangePassword from '../../../components/ChangePassword';
import useStyles from './styles';

interface IChangePasswordModalProps {
  open: boolean;
  onSubmit?: () => void;
}
const ChangePasswordModal = ({ open, onSubmit }: IChangePasswordModalProps) => {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      disableBackdropClick
      disableEscapeKeyDown
      classes={{ paper: classes.paper }}
    >
      <h1  className={classes.title}>
        Redefinição de senha no primeiro acesso
      </h1>
      <ChangePassword onSubmit={onSubmit} />
    </Dialog>
  );
};
export default ChangePasswordModal;
